<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑字段' : '新增字段'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :model="selfData" :rules="rules" label-width="100px">
        <el-form-item label="字段名称:" prop="name">
          <el-input v-model="selfData.name" size="mini" style="width: 250px" />
        </el-form-item>
        <el-form-item label="字段类型:" prop="lei_xing_id">
          <el-select
            v-model="selfData.lei_xing_id"
            size="mini"
            style="width: 250px"
            clearable
            :disabled="!!selfData.id"
            @change="updateType"
          >
            <el-option
              v-for="(item, index) in ziDuanTypeList"
              class="flex flex-x-between"
              :key="index"
              :label="item.key"
              :value="item.val"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        id: null,
        name: '',
        lei_xing_id: null,
        lei_xing_str: ''
      },
      rules: {
        name: [{ required: true, message: '请输入字段名称' }],
        lei_xing_id: [{ required: true, message: '请选择字段类型' }]
      },
      ziDuanTypeList: []
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getListData()
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/ziDuanLeiXing/search',
        data: {
          sortData: {
            id: 'asc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.ziDuanTypeList = res.data.list.map((item) => {
            let result = {
              key: item.name,
              val: item.id
            }
            return result
          })
        }
      })
    },
    // 类型更新
    updateType(val) {
      this.ziDuanTypeList.forEach((item) => {
        if (item.val === val) {
          this.selfData.lei_xing_str = item.key
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/ziDuanKu/saveOrUpdate',
            data: this.selfData
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.popupCancel()
              this.$emit('success')
              this.$message.success('保存成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
